export default __webpack_public_path__ + "img/favicon-apple-touch.75b41d85.png";